import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/recaptcha";
import VueClipboard from "vue-clipboard2";

import VueMeta from "vue-meta";
import NotifyPlugin from "./plugins/notify";
import IconsPlugin from '@/plugins/icons'

Vue.use(IconsPlugin)
Vue.use(VueMeta);
Vue.use(NotifyPlugin);

Vue.use(VueClipboard);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  mounted() {
    setTimeout(() => {
      document.dispatchEvent(new Event("render-event"));
    }, 5000);
  },
}).$mount("#app");
